(function (root, factory) {
  var api = factory()
  if (typeof module !== 'undefined' && module.exports) module.exports = api
  if (root && root.window === root) {
    var tracker = api.installMarketingTracking(root)
    root.AnovatorMarketingTracking = tracker
    if (root.document.currentScript && root.document.currentScript.hasAttribute('data-track-form-page')) tracker.trackFormPage()
  }
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict'

  var ADV_STORAGE_KEY = 'anovator_adv_source'
  var SENT_ADV_KEY_PREFIX = 'anovator_adv_landing_sent:'
  var META_PIXEL_ID = '1894608440919165'

  function parseAdvertisingSource(search) {
    var params = new URLSearchParams(String(search || '').replace(/^\?/, ''))
    var result = { present: false, value: '' }
    params.forEach(function (value, key) {
      if (!result.present && key.toLowerCase() === 'adv') result = { present: true, value: value }
    })
    return result
  }

  function readAdvertisingSource(search, storage) {
    var current = parseAdvertisingSource(search)
    if (current.present) {
      try { storage.setItem(ADV_STORAGE_KEY, JSON.stringify(current)) } catch (error) { void error }
      return current
    }
    try {
      var saved = JSON.parse(storage.getItem(ADV_STORAGE_KEY) || 'null')
      if (saved && saved.present === true && typeof saved.value === 'string') return saved
    } catch (error) { void error }
    return { present: false, value: '' }
  }

  function hasMarketingConsent(win) {
    return Boolean(win.AnovatorConsent && typeof win.AnovatorConsent.hasConsent === 'function' && win.AnovatorConsent.hasConsent('marketing'))
  }

  function trackMetaEvent(win, eventName) {
    if (!hasMarketingConsent(win) || typeof win.fbq !== 'function') return false
    // Keep the direct Pixel's adv and conversion events off the separate GTM Pixel.
    win.fbq('trackSingle', META_PIXEL_ID, eventName)
    return true
  }

  function installMarketingTracking(win) {
    var storage = win.sessionStorage
    var source = readAdvertisingSource(win.location && win.location.search, storage)
    var formPageRequested = false

    function trackLanding() {
      if (!formPageRequested || !source.present || !hasMarketingConsent(win) || typeof win.fbq !== 'function') return
      var sentKey = SENT_ADV_KEY_PREFIX + encodeURIComponent(source.value)
      try { if (storage.getItem(sentKey) === 'true') return } catch (error) { void error }
      trackMetaEvent(win, 'ToFormPage')
      if (source.value) trackMetaEvent(win, 'ToFormPage_' + source.value)
      try { storage.setItem(sentKey, 'true') } catch (error) { void error }
    }

    win.addEventListener('anovator:consent-ready', trackLanding)
    win.addEventListener('anovator:consent-changed', trackLanding)
    win.addEventListener('anovator:marketing-ready', trackLanding)
    trackLanding()

    return {
      getAdvertisingSource: function () { return source },
      trackFormPage: function () {
        formPageRequested = true
        trackLanding()
      },
      trackSuccessfulSubmission: function () {
        if (!hasMarketingConsent(win)) return false
        win.dataLayer = win.dataLayer || []
        win.dataLayer.push({ event: 'contact_submit_success' })
        trackMetaEvent(win, 'CompleteRegistration')
        if (source.value) trackMetaEvent(win, 'Submit_' + source.value)
        return true
      }
    }
  }

  return { parseAdvertisingSource: parseAdvertisingSource, readAdvertisingSource: readAdvertisingSource, installMarketingTracking: installMarketingTracking }
}))
